export { default } from './AuthenticatedRoute';



// WEBPACK FOOTER //
// ./app/components/shared/AuthenticatedRoute/index.js